import script from "./Breadcrumb.vue?vue&type=script&lang=ts&setup=true"
export * from "./Breadcrumb.vue?vue&type=script&lang=ts&setup=true"

import "./Breadcrumb.vue?vue&type=style&index=0&id=37014b49&lang=css"

const __exports__ = script;

export default __exports__